div
<template>
  <div class="by-single-select" v-clickoutside="closePanel">
    <div
      :class="{
        'by-select-input': true,
        'by-select-input-border': isBorder,
        'by-select-input-border__active': isBorder && panelShow,
      }"
      @click="panelShow = !panelShow"
    >
      <!-- <input readonly v-model="text" /> -->
      <span>{{ text || placeholder }}</span>
      <!-- @click="panelShow = !panelShow" -->
      <i
        :class="{
          'el-icon-arrow-down': true,
          'icon-rotate-open': panelShow,
          'icon-rotate-close': !panelShow,
          'span-active': text && !isBorder,
        }"
      ></i>
    </div>
    <el-collapse-transition>
      <div
        :class="{
          'by-panel': true,
          'by-panel-border': isBorder,
          'by-panel-width': isMinWidth,
        }"
        v-show="panelShow"
        @mouseenter="panelOpen = true"
        @mouseleave="panelOpen = false"
      >  
        <slot></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
// import SvgIcon from './SvgIcon.vue';
export default {
  props: {
    value: {
      // 输入框绑定值
      // required: true,
      default: () => {
        return [];
      },
    },
    min: {
      // 最小值
      type: Number,
      required: false,
      default: 0,
    },
    max: {
      // 最大值
      type: Number,
      required: false,
      default: 100,
    },
    slideLabel: {
      type: String,
      default: '',
    },
    // step: {
    //   // 步长
    //   type: Number,
    //   required: false,
    //   default: 1,
    // },

    list: {
      // 下拉数据
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    labelIcon: {
      // 是否显示图标
      type: Boolean,
      required: false,
      default: false,
    },
    labelIconName: {
      // 图标名称
      type: String,
      required: false,
      default: 'fenlei1',
    },
    labelKey: {
      // 显示值的key
      type: String,
      // required: true,
      default: '',
    },
    isInitUpdate: {
      // 初次默认值加载是否需要上传数据
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    isBorder: {
      // 是否显示边框
      type: Boolean,
      default: true,
    },
    isLabelTitle: {
      type: Boolean,
      default: false,
    },
    isMinWidth: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    // SvgIcon,
  },
  data() {
    return {
      sliderValue: [],
      panelShow: false,
      panelOpen: false,
      text: '',
    };
  },
  computed: {},
  watch: {
    // value: {
    //   handler(val) {
    //     // if (this.list.length > 0 && String(val).length > 0) {
    //     //   this.setDefaultValue();
    //     // }
    //     this.sliderValue = val;
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    // list: {
    //   handler(val) {
    //     console.log(66666666);
    //     // 设置默认显示值
    //     if (val.length > 0 && String(this.value).length > 0) {
    //       this.setDefaultValue();
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    panelShow(val) {
      // 获取组件的聚焦状态
      this.$emit('getFocusStatus', val);
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 设置默认值
    setDefaultValue() {
      let defaultItem = this.list.filter(
        (item) => item[this.modelKey] === this.value
      );
      // console.log('this.value', this.value);
      // console.log('defaultItem', defaultItem);
      if (defaultItem.length > 0) {
        // 初次默认值加载是否需要上传数据
        if (this.isInitUpdate) {
          console.log(55555555999999);
          this.handlerClick(defaultItem[0]);
        } else {
          // console.log(defaultItem[0]);
          let item = defaultItem[0];
          if (
            item[this.labelKey] == '全部' &&
            this.placeholder &&
            this.placeholder != '请选择'
          ) {
            this.text = this.placeholder;
          } else {
            this.text = item[this.labelKey];
          }
          this.panelShow = false;
        }
      }
    },
    // 选择下拉值
    handlerClick(item) {
      console.log(55555555);
      if (
        item[this.labelKey] == '全部' &&
        this.placeholder &&
        this.placeholder != '请选择'
      ) {
        this.text = this.placeholder;
      } else {
        this.text = item[this.labelKey];
      }
      this.$emit('input', item[this.modelKey]);
      this.$emit('change', item[this.modelKey]);
      this.panelShow = false;
    },
    // 关闭下拉列表
    closePanel() {
      if (!this.panelOpen) {
        this.panelShow = false;
      }
    },
    slideChange(val) {
      this.$emit('sliderChange', val);
    },
  },
};
</script>

<style scoped lang="scss">
.by-single-select {
  position: relative;
  .by-select-input {
    min-width: 128px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    i {
      display: block;
      font-size: 15px;
      cursor: pointer;
    }
    .icon-rotate-open {
      transition: transform 0.3s;
      transform: rotate(180deg);
    }
    .icon-rotate-close {
      transition: transform 0.3s;
      transform: rotate(0deg);
    }
    span {
      display: inline-block;
      font-size: 13px;
      font-family: 'PingFangSC-Regular', 'Microsoft YaHei', sans-serif;
      font-weight: 400;
      color: #333333;
      line-height: 18px;
    }

    .span-active {
      color: #3370FF;
    }
    input {
      outline: none;
      border: none;
      width: 128px;
      height: 22px;
      background: transparent;
      position: relative;
      cursor: pointer;
      // 文本溢出省略号
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 17px;
      text-align: left;
      font-style: normal;
    }
    input::-webkit-input-placeholder {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #aaa;
      line-height: 17px;
      text-align: left;
      font-style: normal;
    }
  }
  .by-panel {
    position: absolute;
    z-index: 100;
    top: 120%;
    // min-width: 80px;
    // height: 112px;
    min-height: 74px;
    padding: 16px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    box-sizing: border-box;

    .by-panel-list {
      padding: 4px;
      box-sizing: border-box;
      height: auto;
      max-height: 300px;
      // min-width: 80px;
      overflow-x: hidden;
      overflow-y: auto;

      .by-panel-item {
        // width: 160px;
        display: flex;
        align-items: center;
        width: 100%;
        height: 32px;
        padding: 8px;
        white-space: nowrap;
        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;

        &:hover {
          cursor: pointer;
          background: rgba(0, 70, 185, 0.04);
        }

        span {
          display: inline-block;
          font-size: 12px;
          font-family: 'PingFangSC-Regular', 'Microsoft YaHei', sans-serif;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
        }

        .active-color {
          font-family: 'PingFangSC-Medium', 'Microsoft YaHei', sans-serif;
          font-weight: 550;
          color: #0046b9;
        }
      }
    }

    .by-panel-range__title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      line-height: 18px;
      text-align: left;
      font-style: normal;
    }
  }

  .by-select-input-border__active {
    border: 1px solid #3370FF !important;
    &:hover {
      border: 1px solid #3370FF !important;
    }
  }

  .by-select-input-border {
    width: 100%;
    // min-width: 80px;
    justify-content: space-between;
    padding: 6px 10px;
    height: 32px;
    border: 1px solid rgb(220, 223, 230);
    border-radius: 4px;
    transition: 0.2s all;
    box-sizing: border-box;

    &:hover {
      border: 1px solid #aaaaaa;
    }

    &:active {
      border: 1px solid #3370FF;
    }

    &:focus {
      border: 1px solid #3370FF;
    }
  }

  .by-panel-border {
    width: 100%;
  }

  .by-panel-width {
    width: 100%;
    min-width: 240px;
  }
}

.by-type-select ::v-deep .by-panel-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.by-type-select ::v-deep .by-panel-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 4px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  background: #e0e0e0;
}

.by-type-select ::v-deep .by-panel-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  //  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  // -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
  border-radius: 4px;
  background: #fff;
}
</style>
